<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal :title="state.modalTitle" width="70%" :open="true" :confirmLoading="state.loading" :maskClosable="false"
        @ok="onFormSubmit" @cancel="
            () => {
                emit('cancel')
            }
        " :bodyStyle="{ maxHeight: '75vh', overflow: 'auto' }">
        <a-spin :spinning="state.loading">
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="所属栏目" name="cat_id" required>

                    <a-select v-model:value="formState.cat_id" placeholder="请选择栏目" @change="changeCat">
                        <template v-for="(item, index) in state.catList" :key="index">
                            <a-select-option
                                v-if="(user.id == 1 && item.user_id == 1) || (user.id != 1 && item.is_public == 2)"
                                :value="item.id">{{
                                    item.cat_name
                                }}</a-select-option>
                        </template>
                    </a-select>

                </a-form-item>
                <a-form-item label="文章标题" name="title" required>
                    <a-input placeholder="请输入" v-model:value="formState.title"></a-input>
                </a-form-item>
                <template v-if="state.curentCat?.is_public == 1">
                    <a-form-item label="是否公开">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.is_public"
                            checked-children="公开" un-checked-children="仅自己查看"></a-switch>
                    </a-form-item>
                    <a-form-item label="可看用户组" name="restricted_roles" v-if="formState.is_public == 1">
                        <a-select placeholder="请选择角色" v-model:value="formState.public_roles" mode="multiple">
                            <a-select-option v-for="(item, index) in state.roleOptions" :key="index"
                                :value="item.name">{{
                                    item.display_name }}</a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item label="可看用户" name="public_users" v-if="formState.is_public == 1">
                        <UserPick v-model:value="formState.public_users" mode="multiple" placeholder="请输入姓名或手机号">
                        </UserPick>
                    </a-form-item>
                    <a-form-item label="PC是否强制弹出">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.pop_pc"
                            checked-children="是" un-checked-children="否"></a-switch>
                    </a-form-item>
                    <a-form-item label="手机是否强制弹出">
                        <a-switch :checkedValue="1" :unCheckedValue="2" v-model:checked="formState.pop_mb"
                            checked-children="是" un-checked-children="否"></a-switch>
                    </a-form-item>
                </template>
                <a-form-item label="文章内容" name="body" :labelCol="{ span: 7 }" :wrapperCol="{ span: 15 }">
                    <Ueditor v-model:value="formState.body" uid="u2"></Ueditor>
                </a-form-item>
            </a-form>
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed, watch } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import Ueditor from '@/components/Ueditor/index.vue'
import ls from '@/utils/Storage'
import UserPick from '@/components/base/UserPick.vue'
import { debounce } from 'lodash-es'
const user = ls.get('USER_INFO')
const props = defineProps({
    detailData: {
        type: Object,
        default: () => null
    },
    catId: {
        type: Number,
        default: 0
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    modalTitle: string
    loading: boolean
    isEdit: boolean
    roleOptions: any[]
    catList: any[]
    curentCat: any
}
const state = reactive<state>({
    modalTitle: '新增文章',
    loading: false,
    isEdit: false,
    roleOptions: [],
    catList: [],
    curentCat: {}
})
interface formState {
    cat_id: number | null
    title: string
    body: string
    is_public: number
    public_roles: any[]
    public_users: any[]
    pop_pc: number
    pop_mb: number
}
let formState = reactive<formState>({
    cat_id: null,
    title: '',
    body: '',
    is_public: 1,
    public_roles: ['seller'],
    public_users: [],
    pop_pc: 1,
    pop_mb: 1
})
onMounted(() => {
    if (props.detailData?.id) {
        state.modalTitle = '编辑【' + props.detailData.title + '】文章'
        state.isEdit = true
        queryDetail(props.detailData?.id)
    }
    getCatList()
    if (user.id == 1) {
        queryRoleOptions()
    }
})
const queryDetail = (id) => {
    state.loading = true
    let requeryParam = {
        url: `/admin/v1/news/${id}/edit`,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res) => {
            Object.assign(formState, res.data)
            changeCat()
        })
        .finally(() => {
            state.loading = false
        })
}
const onFormSubmit = () => {
    ruleForm.value
        .validate()
        .then(() => {
            state.loading = true
            if (props.detailData?.id > 0) {
                let requeryParam = {
                    url: '/admin/v1/news/' + props.detailData.id,
                    method: 'put',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            } else {
                let requeryParam = {
                    url: '/admin/v1/news',
                    method: 'post',
                    data: formState
                }
                baseService(requeryParam)
                    .then((res: any) => {
                        state.loading = false
                        message.success(res.msg)
                        emit('ok')
                    })
                    .catch((res) => {
                        state.loading = false
                        if (res.msg) {
                            message.error(res.msg)
                        } else {
                            message.error('操作失败')
                        }
                    })
            }
        })
        .catch(() => { })
}
const getCatList = () => {
    let requestParam = {
        url: '/admin/v1/newsCatList',
        method: 'post',
        data: {
            page: 1,
            limit: 'all'
        }
    }
    baseService(requestParam)
        .then((res) => {
            state.loading = false
            state.catList = res.data.list
            if (props.catId) {
                formState.cat_id = props.catId
                changeCat()
            }
        })
        .catch((res) => {
            state.loading = false
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('获取列表失败')
            }
        })
}
const queryRoleOptions = () => {
    let requeryParam = {
        url: '/admin/user/create?id=' + user.id,
        method: 'get'
    }
    baseService(requeryParam)
        .then((res: any) => {
            state.roleOptions = res.data.roles
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败')
            }
        })
}
const changeCat = () => {
    state.curentCat = state.catList.find((item) => item.id == formState.cat_id)
    console.log(state.curentCat)
    if (!state.curentCat || state.curentCat.user_id != user.id) {
        state.curentCat = {}
        formState.cat_id = null
    }
}
</script>

<style lang="less" scoped></style>
